module.exports = __webpack_public_path__ + "img/61.e27a93c1.png";